var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCommentThreeDot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "32px",
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCommentThreeDot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.6,0 C6.70606391,0 -2.13162821e-14,5.38500979 -2.13162821e-14,12.5268439 C-2.13162821e-14,19.667661 6.70606391,25.0526708 15.6,25.0526708 C15.8921664,25.0526708 16.1786194,25.0370348 16.4659813,25.0221616 L16.4849397,25.0212717 L24.0552969,29.9230913 C24.1337273,29.9740671 24.2244937,30 24.3152601,30 C24.3918726,30 24.4693941,29.9814402 24.5392544,29.9444477 C24.6924794,29.8638525 24.7879205,29.7066027 24.7879205,29.5371492 L24.7879205,22.9433375 C28.9262958,20.8366738 31.2,17.1482326 31.2,12.5268439 C31.2,5.38500979 24.4939361,0 15.6,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,22.68 C16.9254834,22.68 18,21.6054834 18,20.28 C18,18.9545166 16.9254834,17.88 15.6,17.88 C14.2745166,17.88 13.2,18.9545166 13.2,20.28 C13.2,21.6054834 14.2745166,22.68 15.6,22.68 Z M15.6,15 C16.9254834,15 18,13.9254834 18,12.6 C18,11.2745166 16.9254834,10.2 15.6,10.2 C14.2745166,10.2 13.2,11.2745166 13.2,12.6 C13.2,13.9254834 14.2745166,15 15.6,15 Z M15.6,7.32 C16.9254834,7.32 18,6.2454834 18,4.92 C18,3.5945166 16.9254834,2.52 15.6,2.52 C14.2745166,2.52 13.2,3.5945166 13.2,4.92 C13.2,6.2454834 14.2745166,7.32 15.6,7.32 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-stream",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photo-preview",
    transform: "translate(-19.000000, -737.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icCommentThreeDot",
    transform: "translate(20.000000, 738.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(15.600000, 12.600000) rotate(90.000000) translate(-15.600000, -12.600000) ",
    xlinkHref: "#path-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommentThreeDot);
export default __webpack_public_path__ + "static/media/icCommentThreeDot.58de6ecf3b37789e9a7bfe894d9e7858.svg";
export { ForwardRef as ReactComponent };